import React from 'react';
import clsx from 'clsx';

const TITLE_WITH_URL = /^(.+?)\s*\((https?:\/\/[^\s)]+)\)\s*$/;

export default function MonitorTitle({ title, className }) {
  const match = title?.match(TITLE_WITH_URL);

  if (!match) {
    return <span className={className}>{title}</span>;
  }

  const [, name, url] = match;

  return (
    <span className={clsx(className, 'flex flex-col')}>
      {name}{' '}
      <br />
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary-dark hover:underline text-xs"
        onClick={e => e.stopPropagation()}
      >
        {url}
      </a>
    </span>
  );
}
